import { atomWithStorage } from 'jotai/utils'

export type TPomegranateAuth = {
  token: string
  centralURL: string
}

export const pomegranateAuthAtom = atomWithStorage<TPomegranateAuth | null>(
  's:pomegranateAuth',
  null,
  undefined,
  { getOnInit: true }
)
